<script>

    import { modalStore } from '../stores'

    import Button from './button.svelte'

    export let modalId = null
    export let text = null
    export let icon = null

</script>

<Button on:click={() => modalStore.open(modalId)} {text} {icon} />